export default __webpack_public_path__ + "images/Lato-Black.font.935697983acee5e867a9b90c8682b9ed.svg";